import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Organisation} from '@/models';
import {OrganisationService} from "@/xhttp/OrganisationService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class OrganisationFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class OrganisationState extends PaginatorFilterState<OrganisationFilter> {
	organisation: Organisation = null;
	organisations: ResultType<Organisation> = null;
	public constructor() {
		super(new OrganisationFilter(), 'organisations', 'organisation', 'id', AscDesc.DESC, 20)
	}
}

class OrganisationStore {

	@XHTTPService(() => Organisation)
	private organisationService: OrganisationService;
	private  _store: Store<any>;

	public state: OrganisationState = new OrganisationState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'organisations', 'organisation'),
	};

	public actions = {
		...StandardAction<Organisation, OrganisationState>(() => Organisation, 'organisation'),
		...PaginatorActionWithFilters<Organisation, OrganisationState>(() => Organisation, 'organisations', 'organisation'),
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new OrganisationStore();
const storeOrganisation = new Vuex.Store(instance);
instance.init(storeOrganisation);

const instancePrix = new OrganisationStore();
export const storeOrganisationPrix = new Vuex.Store(instancePrix);
instancePrix.init(storeOrganisationPrix);

store.registerModule('organisation', storeOrganisation);
store.registerModule('organisationPrix', storeOrganisationPrix);
export default storeOrganisation;